import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Menu, X, ChevronRight } from 'lucide-react';

export default function AboutPage() {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleSignIn = () => {
    navigate('/signin');
  };

  const handleJoinBonndle = () => {
    navigate('/welcome');
  };

  return (
    <div className="landing-page">
      {/* NAV */}
      <nav className="landing-nav">
        <a href="/" className="landing-nav-logo">
          <svg className="landing-nav-logo-mark" width="28" height="28" viewBox="0 0 64 64" fill="none" aria-hidden="true">
            <rect width="64" height="64" rx="14" fill="#4F46E5"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M31.9881 18.2238C29.9158 18.2238 27.9284 19.047 26.463 20.5125C24.9977 21.978 24.1744 23.9656 24.1744 26.038C24.1744 28.1105 24.9977 30.0981 26.463 31.5636C27.9284 33.029 29.9158 33.8523 31.9881 33.8523C34.0604 33.8523 36.0479 33.029 37.5132 31.5636C38.9786 30.0981 39.8018 28.1105 39.8018 26.038C39.8018 23.9656 38.9786 21.978 37.5132 20.5125C36.0479 19.047 34.0604 18.2238 31.9881 18.2238ZM21.942 26.038C21.9432 24.6093 22.2492 23.1972 22.8395 21.896C23.4297 20.5949 24.2907 19.4346 25.3649 18.4927C26.4391 17.5507 27.7019 16.8487 29.0689 16.4335C30.4359 16.0183 31.8758 15.8995 33.2924 16.085C34.7089 16.2705 36.0697 16.756 37.2837 17.5092C38.4978 18.2623 39.5373 19.2658 40.3328 20.4526C41.1283 21.6394 41.6615 22.9822 41.897 24.3915C42.1324 25.8007 42.0645 27.244 41.6979 28.6249C43.0218 29.157 44.2172 29.9649 45.2046 30.9948C46.1921 32.0248 46.9489 33.2532 47.4247 34.5984C47.9005 35.9436 48.0845 37.3747 47.9643 38.7965C47.8441 40.2184 47.4226 41.5983 46.7277 42.8445C46.0329 44.0907 45.0806 45.1747 43.9344 46.0243C42.7881 46.8739 41.474 47.4697 40.0796 47.7719C38.6852 48.0742 37.2425 48.076 35.8473 47.7773C34.4521 47.4787 33.1366 46.8863 31.9881 46.0396C30.8396 46.8822 29.5251 47.4708 28.1318 47.7665C26.7384 48.0623 25.2982 48.0583 23.9065 47.7549C22.5148 47.4515 21.2036 46.8556 20.0597 46.0068C18.9159 45.158 17.9656 44.0756 17.2719 42.8315C16.5782 41.5873 16.157 40.2099 16.0362 38.7906C15.9154 37.3712 16.0978 35.9424 16.5712 34.599C17.0447 33.2555 17.7984 32.028 18.7823 30.9981C19.7662 29.9681 20.9579 29.1592 22.2783 28.6249C22.0551 27.7808 21.942 26.9112 21.942 26.038ZM23.088 30.7058C21.4115 31.3906 20.0248 32.6364 19.1648 34.2302C18.3049 35.8241 18.0249 37.6671 18.3728 39.4444C18.7207 41.2218 19.6749 42.8231 21.0724 43.975C22.4699 45.1269 24.2239 45.7577 26.0348 45.7598C27.2306 45.7602 28.4106 45.4862 29.4838 44.9587C30.557 44.4313 31.4948 43.6645 32.225 42.7176C32.9553 41.7706 33.4585 40.6686 33.6958 39.4965C33.9331 38.3244 33.8983 37.1135 33.594 35.957C31.5134 36.2941 29.3795 35.9683 27.4943 35.0257C25.6091 34.083 24.0681 32.5712 23.0895 30.7043M35.7461 35.3571C35.9664 36.1832 36.0825 37.051 36.0825 37.944C36.0865 40.3431 35.2282 42.6638 33.664 44.4827C34.5758 45.0761 35.6015 45.4725 36.6753 45.6465C37.7491 45.8206 38.8475 45.7685 39.9 45.4935C40.9526 45.2186 41.9361 44.7269 42.7877 44.0499C43.6392 43.3729 44.3401 42.5255 44.8453 41.562C45.3505 40.5986 45.649 39.5402 45.7216 38.4547C45.7943 37.3692 45.6395 36.2804 45.2671 35.2582C44.8948 34.236 44.3131 33.3028 43.5593 32.5184C42.8055 31.7339 41.8963 31.1155 40.8898 30.7028C39.779 32.8134 37.9568 34.4623 35.7461 35.3571Z" fill="white"/>
          </svg>
          <span className="landing-nav-wordmark">bonndle</span>
        </a>
        <div className="landing-nav-buttons">
          <button onClick={handleSignIn} className="landing-btn-signin">
            Sign In
          </button>
          <button onClick={handleJoinBonndle} className="landing-btn-join">
            Join bonndle
          </button>
        </div>
        <button
          className="landing-nav-burger"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <Menu size={24} />
        </button>
      </nav>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && <div className="landing-mobile-menu-backdrop" onClick={() => setMobileMenuOpen(false)} />}
      <div className={`landing-mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <button
          className="landing-mobile-menu-close"
          onClick={() => setMobileMenuOpen(false)}
          aria-label="Close menu"
        >
          <X size={24} />
        </button>
        <div className="landing-mobile-menu-content">
          <button onClick={() => { handleSignIn(); setMobileMenuOpen(false); }} className="landing-mobile-menu-link">
            <span>Sign In</span>
            <ChevronRight size={20} />
          </button>
          <button onClick={() => { handleJoinBonndle(); setMobileMenuOpen(false); }} className="landing-mobile-menu-link">
            <span>Join bonndle</span>
            <ChevronRight size={20} />
          </button>
          <Link to="/about" className="landing-mobile-menu-link" onClick={() => setMobileMenuOpen(false)}>
            <span>About</span>
            <ChevronRight size={20} />
          </Link>
          <a href="mailto:support@bonndle.com" className="landing-mobile-menu-link" onClick={() => setMobileMenuOpen(false)}>
            <span>Support</span>
            <ChevronRight size={20} />
          </a>
          <a href="#" className="landing-mobile-menu-link" onClick={() => setMobileMenuOpen(false)}>
            <span>Terms</span>
            <ChevronRight size={20} />
          </a>
        </div>
      </div>

      {/* About Hero - Same gradient design as landing page */}
      <section className="about-hero about-hero-compact landing-canvas-bg">
        <div className="landing-aurora"></div>
        <div className="about-hero-content">
          <h1 className="about-title">
            About <em>bonndle</em>
          </h1>
        </div>
      </section>

      {/* Tagline Section with BgCanvas background */}
      <div className="about-quote-section">
        <div className="about-quote">
          Making life's experiences more rewarding together
        </div>
      </div>

      {/* About Content */}
      <div className="about-body">
        <div className="about-content">
          <p className="about-verse">"Two are better than one, for they have a good reward ...from life's experiences." — Ecclesiastes 4:9 (Paraphrased)</p>
          <p>Inspired by this age-long principle, Bonndle was founded with a mission to make life's experiences more rewarding together.</p>
          <p>We all belong to groups. Yet most of us pay solo for products and services that power life's experiences. The result? We spend more and miss the combined economic value our groups could unlock.</p>
          <p>Our goal is to address this by turning shared interests into shared savings that enable people achieve more with their groups.</p>
          <p>Because life is better together.</p>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="landing-footer">
        <span className="landing-footer-copy">© 2026 bonndle. All Rights Reserved.</span>
        <span className="landing-footer-tagline">Better. Together.</span>
        <div className="landing-footer-right">
          <div className="landing-footer-links">
            <Link to="/about" className="landing-footer-link-btn">About</Link>
            <span className="landing-footer-dot">·</span>
            <a href="#">Terms</a>
            <span className="landing-footer-dot">·</span>
            <a href="#">Privacy</a>
          </div>
          <div className="landing-footer-contact">
            <a href="mailto:support@bonndle.com">support@bonndle.com</a>
            <span className="landing-footer-dot"> · </span>
            <a href="https://instagram.com/bonndleapp" target="_blank" rel="noopener noreferrer">@bonndleapp</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
